import { fromRefinement } from 'io-ts/Decoder';

export const neverDecoder = fromRefinement((_): _ is never => false, 'never');
